/* ============ counting systems ============ */

export const CV = {
  "Hi-Lo":     { A: -1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 1, 7: 0, 8: 0, 9: 0, 10: -1, J: -1, Q: -1, K: -1 },
  "KO":        { A: -1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 1, 7: 1, 8: 0, 9: 0, 10: -1, J: -1, Q: -1, K: -1 },
  "Hi-Opt I":  { A: 0,  2: 0, 3: 1, 4: 1, 5: 1, 6: 1, 7: 0, 8: 0, 9: 0, 10: -1, J: -1, Q: -1, K: -1 },
  "Hi-Opt II": { A: 0,  2: 1, 3: 1, 4: 2, 5: 2, 6: 1, 7: 1, 8: 0, 9: 0, 10: -2, J: -2, Q: -2, K: -2 },
  "Omega II":  { A: 0,  2: 1, 3: 1, 4: 2, 5: 2, 6: 2, 7: 1, 8: 0, 9: -1, 10: -2, J: -2, Q: -2, K: -2 },
  "Zen":       { A: -1, 2: 1, 3: 1, 4: 2, 5: 2, 6: 2, 7: 1, 8: 0, 9: 0, 10: -2, J: -2, Q: -2, K: -2 },
};

export const BALANCED = {
  "Hi-Lo": true, "KO": false, "Hi-Opt I": true,
  "Hi-Opt II": true, "Omega II": true, "Zen": true,
};

export const SYSTEMS = Object.keys(CV);

/* Counting systems eligible for RANKED play / leaderboards: the ones with a
   verified deviation index set (see INDICES in deviations.js). Other systems
   stay casual-only. Keep this list in sync with INDICES. */
export const RANKABLE_SYSTEMS = ["Hi-Lo", "Zen"];

/* KO key counts by deck count (bet ramp trigger for the unbalanced system) */
export const KO_KEY = { 1: 2, 2: 1, 4: -1, 6: -4, 8: -6 };

/* initial running count: KO starts below zero on multi-deck shoes */
export const irc = (st) => (st.system === "KO" ? -4 * (st.decks - 1) : 0);

export const cardValue = (st, card) => CV[st.system][card.r];

/* decks remaining, estimated the way a counter does at the table —
   the unseen dealer hole card still counts as "in play" */
export function decksRemaining(g) {
  const hidden = g.dealer && !g.dealer.holeUp ? 1 : 0;
  return Math.max(0.5, Math.round(((g.shoe.length + hidden) / 52) * 2) / 2);
}

export const trueCount = (g) => g.rc / decksRemaining(g);

/* suggested bet in units for the current count */
export function recommendedUnits(g, st) {
  if (BALANCED[st.system]) {
    const tc = Math.floor(trueCount(g));
    if (tc <= 1) return 1;
    const ramp = { 2: 2, 3: 4, 4: 6 }[tc] ?? 8;
    return Math.min(ramp, st.spread);
  }
  const key = KO_KEY[st.decks] ?? -4;
  if (g.rc < key) return 1;
  return Math.min(1 + (g.rc - key), st.spread);
}
